import React from 'react'
import DeliveryPerfDashboard from './deliveryperfdashboard.js';
import ShipmentDashboard2 from './shipmentdashboard2.js';
import DelayDashboard from './delaydashboard.js';
import APIHealthCheckDashboard from './apihealthcheckdashboard.js';
import PODCompletionDashboard from './podcompletiondashboard.js';
import TrackingCompletionDashboard from './trackingcompletiondashboard.js';
import DEPSReportedDashboard from './depsreporteddashboard.js';
import DeliveryPerfDashboard2 from './deliveryperfdashboard2.js';
import SLAAdherenceDashboard from './slaadherencedashboard.js';
import DepsDashboard2 from './depsdashboard2.js';
import ShipmentDashboard from './shipmentdashboard.js';
import Dashboard2 from './dashboard2.js';


const Dashboards=() =>{
  return (
    <>
    <div className="row">
        <div className="col-sm-12">
            <h5 className="f18">
                <i class="icofont icofont-pie cus-i"></i>
                Dashboard
            </h5>
        </div>
    </div>
    <div className=''>
        {/* <div className='row'>
            <div className='col-6 mb-20p'>
            <DeliveryPerfDashboard2/>
            </div>
            <div className='col-6 mb-20p'>
            <DelayDashboard/>
            </div>
        </div> */}
        <div className='row'>
            {/* <div className='col-6 mb-20p'>
            <ShipmentDashboard/>
            </div> */}
            <div className='col-6 mb-20p'>
            <ShipmentDashboard2/>
            </div>
            {/* <div className='col-6 mb-20p'>
            <APIHealthCheckDashboard/>
            </div> */}
            <div className='col-6 mb-20p'>
            <PODCompletionDashboard/>
            </div>
            
        </div>
        <div className='row'>
            
            <div className='col-6 mb-20p'>
            <TrackingCompletionDashboard/>
            </div>
            <div className='col-6 mb-20p'>
            <DEPSReportedDashboard/>
            </div>
        </div>
        <div className='row'>
            <div className='col-12 mb-20p'>
            <SLAAdherenceDashboard/>
            </div>
            {/* <div className='col-6 mb-20p'>
            <DeliveryPerfDashboard2/>
            </div> */}
            
        </div>
        <div className='row'>
            
            {/* {/* <div className='col-6 mb-20p'>
            <Dashboard2/>
            </div> */}
        </div>
    </div>
  
    </>
  )
}

export default Dashboards;